import PropTypes from 'prop-types';
import React from 'react';

const Transition = ({ children }) => {
  return <div>{children}</div>;
};

Transition.propTypes = {
  children: PropTypes.node.isRequired,
  location: PropTypes.object.isRequired,
};

export default Transition;
